import { Link } from "react-router-dom";
import { heroComic } from "@/mocks/comics";

export default function Hero() {
  return (
    <section className="relative flex min-h-[620px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=soft%20pastel%20anime%20illustration%20of%20a%20dreamy%20pink%20patisserie%20dessert%20shop%20scene%20with%20sweet%20cakes%20cookies%20and%20sparkling%20warm%20light%2C%20cute%20manga%20style%2C%20romantic%20fluffy%20clouds%2C%20cozy%20clean%20composition%2C%20gentle%20glow%20and%20soft%20bokeh&width=1600&height=900&seq=hero-dessert&orientation=landscape"
        alt="可可漫画网 萌系甜宠少女漫 首页背景"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-900/55 to-primary-950/75" />

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-sparkling-2-fill text-primary-200" />
          今日编辑推荐
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-5xl">
          {heroComic.title}
        </h1>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
          {heroComic.tags.map((t) => (
            <span key={t} className="rounded-full bg-background-50/15 px-3 py-1 text-sm text-background-50/90">
              {t}
            </span>
          ))}
        </div>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/85">
          {heroComic.intro}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to={`/comic/${heroComic.id}`}
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-400"
          >
            立即开始阅读
          </Link>
          <Link
            to="/#rank"
            className="whitespace-nowrap rounded-full border border-background-50/40 px-7 py-3 text-base text-background-50 backdrop-blur transition-colors hover:bg-background-50/15"
          >
            看看热门排行
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-3 gap-6 text-center">
          {[
            { num: "300+", label: "部连载漫画" },
            { num: "每日", label: "准时更新" },
            { num: "免费", label: "在线畅读" },
          ].map((s) => (
            <div key={s.label}>
              <p className="font-heading text-2xl text-background-50">{s.num}</p>
              <p className="mt-1 text-sm text-background-50/75">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}